import Vue from "vue";
import Router from "vue-router";

import Homepage from "./views/Homepage.vue";

// SECTIONS
import NotificationsList from "./components/NotificationsList.vue";
import BaseListPage from "./views/sections/BaseListPage.vue";

import DummyView from "./views/sections/DummyView.vue";

import store from "./store";
import Utils from "./Utils";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    // AUTH PAGES
    {
      path: "/",
      name: "login",
      component: Homepage,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/hfOffice/:hfOfficeId/:redirectType/slaType/:slaType",
      name: "login",
      component: Homepage,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/firstLogin/:token",
      name: "firstLogin",
      component: Homepage,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/password-recovery",
      name: "passwordRecovery",
      component: Homepage,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/username-recovery",
      name: "usernameRecovery",
      component: Homepage,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/newPassword/:tempToken",
      name: "newPassword",
      component: Homepage,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/change-password",
      name: "changePassword",
      component: Homepage,
      meta: {
        requiresAuth: false
      }
    },
    // HF SELECTION
    {
      path: "/hf-overview",
      name: "hfSelection",
      component: () => import("./views/sections/HFSelection.vue"),
      meta: {
        requiresAuth: true
      }
    },
    // WORKSPACE
    {
      path: "/workspace",
      name: "workspace",
      component: () => import("./views/Workspace.vue"),
      redirect: {
        name: "home"
      },
      meta: {},
      children: [
        {
          path: "profile",
          name: "profile",
          component: () => import("./views/sections/Profile.vue"),
          meta: {
            requiresAuth: true
          }
        },
        // HOME
        {
          path: "home",
          name: "home",
          component: () => import("./views/sections/Home.vue"),
          meta: {
            requiresAuth: true
          }
        },
        // OPERATORS
        {
          path: "operators",
          component: DummyView,
          name: "operators",
          redirect: {
            name: "_operators"
          },
          meta: {},
          children: [
            {
              path: "",
              name: "_operators",
              component: BaseListPage,
              props: {
                type: "operators",
                storeType: "operators",
                showSort: true
              },
              meta: {
                isAbstract: true,
                requiresAuth: true,
                permName: "GESTIONEPROFILI"
              }
            },
            {
              path: "new",
              name: "operatorNew",
              component: () => import("./views/sections/OperatorNew.vue"),
              meta: {
                requiresAuth: true,
                accessRights: {
                  permName: "GESTIONEPROFILI",
                  minimumPermissions: "READWRITE",
                  fallbackRoute: {
                    name: "operators"
                  }
                }
              },
              beforeEnter: checkUserAuthorization
            },
            {
              path: "edit/:id",
              name: "operatorEdit",
              component: () => import("./views/sections/OperatorEdit.vue"),
              meta: {
                requiresAuth: true,
                accessRights: {
                  permName: "GESTIONEPROFILI",
                  minimumPermissions: "READ",
                  fallbackRoute: {
                    name: "operators"
                  }
                }
              },
              beforeEnter: checkUserAuthorization
            }
          ]
        },
        // PAYMENTS
        {
          path: "payments",
          name: "payments",
          component: DummyView,
          meta: {},
          redirect: {
            name: "_payments"
          },
          children: [
            {
              path: "",
              name: "_payments",
              component: () => import("./views/sections/Payments.vue"),
              meta: {
                isAbstract: true,
                requiresAuth: true,
                permName: "RENDICONTAZIONE"
              }
            },
            {
              path: "details/:id",
              name: "billPaymentDetails",
              component: () =>
                import("./views/sections/BillPaymentDetails.vue"),
              meta: {
                isAbstract: true,
                requiresAuth: true,
                permName: "RENDICONTAZIONE"
              }
            }
          ]
        },
        // HF MANAGEMENT
        {
          path: "office-management",
          name: "officeAdministration",
          component: DummyView,
          meta: {},
          redirect: {
            name: "_officeAdministration"
          },
          children: [
            {
              path: "",
              name: "_officeAdministration",
              component: () => import("./views/sections/HFManagement.vue"),
              meta: {
                isAbstract: true,
                requiresAuth: true,
                permName: "GESTIONESTRUTTURASANITARIA"
              }
            },
            {
              path: "services",
              name: "hfServices",
              component: DummyView,
              meta: {},
              redirect: {
                name: "_hfServices"
              },
              children: [
                {
                  path: "",
                  name: "_hfServices",
                  component: () => import("./views/sections/HFServices.vue"),
                  meta: {
                    isAbstract: true,
                    requiresAuth: true,
                    permName: "GESTIONESTRUTTURASANITARIA"
                  }
                },
                {
                  path: ":id/new-slot",
                  name: "hfServiceAvailability",
                  component: () =>
                    import("./views/sections/HFServiceAvailability.vue"),
                  meta: {
                    requiresAuth: true,
                    permName: "GESTIONESTRUTTURASANITARIA"
                  }
                }
              ]
            },
            {
              path: "hf-staff",
              name: "hfStaff",
              component: DummyView,
              meta: {
                requiresAuth: true,
                permName: "GESTIONESTRUTTURASANITARIA"
              },
              redirect: {
                name: "_hfStaff"
              },
              children: [
                {
                  path: "",
                  name: "_hfStaff",
                  component: BaseListPage,
                  props: {
                    type: "hfManagement.officeStaff",
                    storeType: "doctors",
                    routeNameToGo: "_officeAdministration"
                  },
                  meta: {
                    isAbstract: true,
                    requiresAuth: true,
                    permName: "GESTIONESTRUTTURASANITARIA"
                  }
                }
              ]
            },
            {
              path: "doctor-suspension",
              name: "hfDoctorSuspension",
              component: () =>
                import("./views/sections/HFDoctorSuspension.vue"),
              meta: {
                requiresAuth: true,
                permName: "GESTIONESTRUTTURASANITARIA"
              }
            },
            {
              path: "machinery-performance",
              name: "hfMachineryPerformance",
              component: BaseListPage,
              props: {
                type: "hfManagement.machineryPerformance",
                storeType: "machinery",
                routeNameToGo: "_officeAdministration"
              },
              meta: {
                requiresAuth: true,
                permName: "GESTIONESTRUTTURASANITARIA"
              }
            },
            {
              path: "machinery-suspension",
              name: "hfMachinerySuspension",
              component: () =>
                import("./views/sections/HFMachinerySuspension.vue"),
              meta: {
                requiresAuth: true,
                permName: "GESTIONESTRUTTURASANITARIA"
              }
            },
            {
              path: "performance-suspension",
              name: "hfPerformanceSuspension",
              component: () =>
                import("./views/sections/HFPerformanceSuspension.vue"),
              meta: {
                requiresAuth: true,
                permName: "GESTIONESTRUTTURASANITARIA"
              }
            }
          ]
        },
        // GENERAL INFO
        {
          path: "general-info",
          name: "hfGeneralInfo",
          component: DummyView,
          meta: {},
          redirect: {
            name: "_hfGeneralInfo"
          },
          children: [
            {
              path: "",
              name: "_hfGeneralInfo",
              component: () => import("./views/sections/HFGeneralInfo.vue"),
              meta: {
                isAbstract: true,
                requiresAuth: true,
                permName: "GESTIONESTRUTTURASANITARIA"
              }
            }
          ]
        },
        // BILLS
        {
          path: "bills",
          name: "bills",
          component: DummyView,
          redirect: {
            name: "_bills"
          },
          meta: {},
          children: [
            {
              path: "",
              name: "_bills",
              component: BaseListPage,
              props: {
                type: "bills",
                storeType: "bills",
                actionButton: {
                  label: "newBill",
                  icon: "fas fa-file-medical",
                  routeName: "newBill"
                },
                contentOptions: {
                  dataType: "draft"
                }
              },
              meta: {
                isAbstract: true,
                requiresAuth: true,
                permName: "RENDICONTAZIONE"
              }
            },
            {
              path: "new-bill",
              name: "newBill",
              redirect: {
                name: "_newBill"
              },
              component: DummyView,
              meta: {},
              children: [
                {
                  path: "",
                  name: "_newBill",
                  component: () => import("./views/sections/NewBill.vue"),
                  props: {
                    type: "billAppointments",
                    storeType: "billAppointments",
                    contentType: "new"
                  },
                  meta: {
                    isAbstract: true,
                    requiresAuth: true,
                    accessRights: {
                      permName: "RENDICONTAZIONE",
                      minimumPermissions: "READWRITE",
                      fallbackRoute: {
                        name: "bills"
                      }
                    }
                  },
                  beforeEnter: checkUserAuthorization
                },
                // BILL APPOINTMENTS DONE
                {
                  path: "appointments",
                  name: "billNewAppointmentList",
                  component: BaseListPage,
                  props: {
                    type: "billAppointments",
                    storeType: "billAppointments",
                    routeNameToGo: "_newBill",
                    contentOptions: {
                      dataType: "new"
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    permName: "RENDICONTAZIONE"
                  },
                  beforeEnter(to, from, next) {
                    store.commit("billAppointments/SET_TO_FILTER", "DONE");
                    store.commit(
                      "billAppointments/SET_PAGE_TITLE",
                      "appointmentsNoBill"
                    );
                    store.commit(
                      "billAppointments/SET_PAGE_TEXT",
                      "appointmentsNoBillText"
                    );
                    next();
                  }
                },
                // BILL APPOINTMENTS ACCEPTED
                {
                  path: "other-appointments",
                  name: "_billNewAcceptedAppointmentList",
                  component: BaseListPage,
                  props: {
                    type: "billAppointments",
                    storeType: "billAppointments",
                    routeNameToGo: "billNewAppointmentList",
                    contentOptions: {
                      dataType: "new"
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    permName: "RENDICONTAZIONE"
                  },
                  beforeEnter(to, from, next) {
                    store.commit("billAppointments/SET_TO_FILTER", "ACCEPTED");
                    store.commit(
                      "billAppointments/SET_PAGE_TITLE",
                      "otherAppointmentsNoBill"
                    );
                    store.commit(
                      "billAppointments/SET_PAGE_TEXT",
                      "otherAppointmentsNoBillText"
                    );
                    next();
                  }
                },
                {
                  path: "documents",
                  name: "newBillDocsMgmt",
                  component: () =>
                    import("./views/sections/BillFileUpload.vue"),
                  meta: {
                    requiresAuth: true,
                    accessRights: {
                      permName: "RENDICONTAZIONE",
                      minimumPermissions: "READWRITE",
                      fallbackRoute: {
                        name: "bills"
                      }
                    }
                  },
                  beforeEnter: checkUserAuthorization
                }
              ]
            },
            {
              path: "details/:id",
              name: "billDetails",
              component: DummyView,
              children: [
                {
                  path: "",
                  name: "_billDetails",
                  component: () => import("./views/sections/EditBill.vue"),
                  meta: {
                    isAbstract: true,
                    requiresAuth: true,
                    permName: "RENDICONTAZIONE"
                  }
                },
                {
                  path: "appointments",
                  name: "billUpdateAppointmentList",
                  component: BaseListPage,
                  props: {
                    type: "billAppointments",
                    storeType: "billAppointments",
                    routeNameToGo: "_billDetails",
                    contentOptions: {
                      dataType: "edit"
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    permName: "RENDICONTAZIONE"
                  },
                  beforeEnter(to, from, next) {
                    store.commit("billAppointments/SET_TO_FILTER", "DONE");
                    store.commit(
                      "billAppointments/SET_PAGE_TITLE",
                      "appointments"
                    );
                    store.commit(
                      "billAppointments/SET_PAGE_TEXT",
                      "appointmentsText"
                    );
                    next();
                  }
                },
                {
                  path: "other-appointments",
                  name: "_billEditAcceptedAppointmentList",
                  component: BaseListPage,
                  props: {
                    type: "billAppointments",
                    storeType: "billAppointments",
                    routeNameToGo: "billUpdateAppointmentList",
                    contentOptions: {
                      dataType: "edit"
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    permName: "RENDICONTAZIONE"
                  },
                  beforeEnter(to, from, next) {
                    store.commit("billAppointments/SET_TO_FILTER", "ACCEPTED");
                    store.commit(
                      "billAppointments/SET_PAGE_TITLE",
                      "otherAppointments"
                    );
                    store.commit(
                      "billAppointments/SET_PAGE_TEXT",
                      "otherAppointmentsText"
                    );
                    next();
                  }
                },
                {
                  path: "documents",
                  name: "updateBillDocsMgmt",
                  component: () =>
                    import("./views/sections/BillFileUpload.vue"),
                  meta: {
                    requiresAuth: true,
                    accessRights: {
                      permName: "RENDICONTAZIONE",
                      minimumPermissions: "READWRITE",
                      fallbackRoute: {
                        name: "billDetails"
                      }
                    }
                  },
                  beforeEnter: checkUserAuthorization
                }
              ]
            }
          ]
        },
        {
          path: "bills",
          name: "bills",
          component: DummyView,
          redirect: {
            name: "_bills-sentback"
          },
          meta: {},
          children: [
            {
              path: "",
              name: "_bills-sentback",
              component: BaseListPage,
              props: {
                type: "bills",
                storeType: "bills",
                contentOptions: {
                  dataType: "sentback"
                }
              },
              meta: {
                isAbstract: true,
                requiresAuth: true,
                permName: "RENDICONTAZIONE"
              }
            },
            {
              path: "details/:id",
              name: "billDetails",
              component: DummyView,
              children: [
                {
                  path: "",
                  name: "_billDetails",
                  component: () => import("./views/sections/EditBill.vue"),
                  meta: {
                    isAbstract: true,
                    requiresAuth: true,
                    permName: "RENDICONTAZIONE"
                  }
                }
              ]
            }
          ]
        },
        // APPOINTMENTS
        {
          path: "appointments",
          name: "appointments",
          component: DummyView,
          meta: {},
          redirect: {
            name: "requestAppointments"
          },
          children: [
            {
              path: "requests",
              name: "requestAppointments",
              component: DummyView,
              redirect: {
                name: "_request-appointments"
              },
              children: [
                // APPOINTMENTS / REQUESTS
                {
                  path: "",
                  name: "_request-appointments",
                  component: BaseListPage,
                  props: {
                    type: "appointments",
                    storeType: "appointments",
                    contentOptions: {
                      dataType: "request"
                    }
                  },
                  meta: {
                    isAbstract: true,
                    requiresAuth: true,
                    permName: "GESTIONERICHIESTE"
                  }
                },
                {
                  path: "details/:id?",
                  name: "appointmentManagement",
                  component: DummyView,
                  redirect: {
                    name: "_appointmentManagement"
                  },
                  children: [
                    {
                      path: "",
                      component: () =>
                        import("./views/sections/AppointmentManagement.vue"),
                      name: "_appointmentManagement",
                      meta: {
                        isAbstract: true,
                        requiresAuth: true,
                        permName: "GESTIONERICHIESTE"
                      },
                      beforeEnter(to, from, next) {
                        store.commit("bills/SET_ACTIVE_PROVIDED_SERVICE", null);
                        store.commit("bills/SET_ACTIVE_BILL_INFO", null);
                        next();
                      }
                    }
                  ]
                }
              ]
            },
            {
              path: "bookings",
              name: "bookingAppointments",
              component: DummyView,
              redirect: {
                name: "_booking-appointments"
              },
              children: [
                // APPOINTMENTS / BOOKINGS
                {
                  path: "",
                  name: "_booking-appointments",
                  component: BaseListPage,
                  props: {
                    type: "appointments",
                    storeType: "appointments",
                    contentOptions: {
                      dataType: "booking"
                    }
                  },
                  meta: {
                    isAbstract: true,
                    requiresAuth: true,
                    permName: "GESTIONERICHIESTE"
                  }
                },
                {
                  path: "details/:id?",
                  name: "appointmentManagement",
                  component: DummyView,
                  redirect: {
                    name: "_appointmentManagement"
                  },
                  children: [
                    {
                      path: "",
                      component: () =>
                        import("./views/sections/AppointmentManagement.vue"),
                      name: "_appointmentManagement",
                      meta: {
                        isAbstract: true,
                        requiresAuth: true,
                        permName: "GESTIONERICHIESTE"
                      },
                      beforeEnter(to, from, next) {
                        store.commit("bills/SET_ACTIVE_PROVIDED_SERVICE", null);
                        store.commit("bills/SET_ACTIVE_BILL_INFO", null);
                        next();
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        // MEMBERS
        {
          path: "members",
          name: "membersManagement",
          component: () => import("./views/sections/MembersList.vue"),
          props: {
            type: "members",
            storeType: "members"
          },
          meta: {
            requiresAuth: true,
            permName: "GESTIONERICHIESTE"
          }
        },
        {
          path: "members/:id/details",
          name: "member",
          component: () => import("./views/sections/MemberDetails.vue"),
          props: {
            type: "members",
            storeType: "memberAppointments"
          },
          meta: {
            requiresAuth: true,
            permName: "GESTIONERICHIESTE"
          }
        },
        {
          path: "members/:id/details/new-booking",
          name: "bookingWizard",
          component: () => import("./views/sections/BookingWizard.vue"),
          meta: {
            requiresAuth: true,
            permName: "GESTIONERICHIESTE"
          }
        },
        // NOTIFICATIONS
        {
          path: "notifications-center",
          name: "notificationsCenter",
          component: DummyView,
          redirect: {
            name: "_notificationsCenter"
          },
          meta: {},
          children: [
            {
              path: "",
              name: "_notificationsCenter",
              props: {
                type: "notificationsCenter",
                storeType: "notifications"
              },
              meta: {
                isAbstract: true,
                requiresAuth: true,
                permName: "CENTRONOTIFICHE"
              },
              component: NotificationsList
            }
          ]
        },
        // NEWS & TUTS
        {
          path: "news-tutorial",
          name: "newsTutorial",
          redirect: {
            name: "_newsTutorial"
          },
          meta: {},
          component: DummyView,
          children: [
            {
              path: "",
              name: "_newsTutorial",
              props: {
                type: "newsTutorial",
                storeType: "newsTutorial"
              },
              meta: {
                isAbstract: true,
                requiresAuth: true,
                permName: "NEWSTUTORIAL"
              },
              component: BaseListPage
            },
            {
              path: "details/:id",
              name: "newsTutorialDetails",
              component: () =>
                import("./views/sections/NewsTutorialDetails.vue"),
              meta: {
                requiresAuth: true,
                permName: "CENTRONOTIFICHE"
              }
            },
            // FEEDBACK
            {
              path: "feedback",
              name: "feedback",
              component: () => import("./views/sections/Feedback.vue"),
              meta: {
                requiresAuth: true,
                permName: "NEWSTUTORIAL"
              }
            }
          ]
        },
        // FAQ
        {
          path: "faq",
          name: "faq",
          component: () => import("./views/sections/Faq.vue"),
          meta: {
            requiresAuth: true,
            permName: "FAQ"
          }
        },
        // CONTACT
        {
          path: "contact",
          name: "contact",
          component: () => import("./views/sections/Contact.vue"),
          meta: {
            requiresAuth: true,
            permName: "CONTATTI"
          }
        }
      ]
    },
    {
      path: "*",
      name: "404",
      beforeEnter: (to, from, next) => {
        const FAKE_DELAY = 500;
        setTimeout(() => {
          store.commit(
            "error/SET_ERROR",
            {
              type: Utils.errorTypes.CUSTOM,
              title: "dialogs.error.pageNotFound.title",
              msg: "dialogs.error.pageNotFound.msg",
              actionBtn: "dialogs.error.pageNotFound.btn"
            },
            {
              root: true
            }
          );
        }, FAKE_DELAY);

        const lastRoute = JSON.parse(sessionStorage.getItem("LS_ROUTE"));
        next({
          name: lastRoute.name,
          params: lastRoute.params,
          query: lastRoute.query
        });
      }
    }
  ],
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

function checkUserAuthorization(to, from, next) {
  const MINIMUM_PERMISSIONS = to.meta.accessRights.minimumPermissions;
  const PERM_NAME = to.meta.accessRights.permName;
  const FALLBACK_ROUTE = to.meta.accessRights.fallbackRoute;
  const HAS_ACCESS = store.getters["auth/userHasRequiredAccess"](
    PERM_NAME,
    MINIMUM_PERMISSIONS
  );
  if (HAS_ACCESS) {
    next();
  } else {
    next(FALLBACK_ROUTE);
  }
}

router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  // Start the route progress bar.
  if (to.name) {
    let LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
    store.commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
      root: true
    });
    if (to.path === "/login") {
      next({
        name: "login"
      });
    } else if (to.name === "bookingWizard") {
      if (to.query && to.query.q) {
        let activeStep = store.getters["bookings/getStepByName"](to.query.q);
        let appointmentId = store.getters["bookings/getAppointmentId"];
        if (
          !appointmentId &&
          activeStep &&
          (activeStep.visited || activeStep.active)
        ) {
          next();
        } else if (
          appointmentId &&
          activeStep &&
          (activeStep.visited || activeStep.active)
        ) {
          next();
        } else {
          let currentStepName = store.getters["bookings/getCurrentStep"].name;
          next({ name: "bookingWizard", query: { q: currentStepName } });
        }
      }
    } else {
      next();
    }
  }

  store.commit("bills/setLastPathLocation", to.fullPath);

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // CHECK IF USER IS ALREADY AUTHENTICATED
    let isLoggedIn = store.getters["auth/isUserLoggedIn"];
    if (!isLoggedIn) {
      next({
        name: "login"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

const FAKE_DELAY_LOADING_PAGES = [
  "profile",
  "_newBill",
  "newsTutorialDetails",
  "membersManagement"
];

// afterEach can manage to, from routes
router.afterEach(to => {
  sessionStorage.setItem(
    "LS_ROUTE",
    JSON.stringify({
      name: to.name,
      params: to.params,
      query: to.query
    })
  );

  let fakeDelay = 0;
  if (FAKE_DELAY_LOADING_PAGES.includes(to.name)) {
    fakeDelay = 1000;
  }
  setTimeout(() => {
    store.commit("loading/CLOSE_LOADING_DIALOG", {
      root: true
    });
  }, fakeDelay);
});

export default router;
